"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserDetail = instanceOfUserDetail;
exports.UserDetailFromJSON = UserDetailFromJSON;
exports.UserDetailFromJSONTyped = UserDetailFromJSONTyped;
exports.UserDetailToJSON = UserDetailToJSON;
exports.UserDetailToJSONTyped = UserDetailToJSONTyped;
/**
 * Check if a given object implements the UserDetail interface.
 */
function instanceOfUserDetail(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isStaff' in value) || value['isStaff'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function UserDetailFromJSON(json) {
    return UserDetailFromJSONTyped(json, false);
}
function UserDetailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'username': json['username'],
        'email': json['email'],
        'isStaff': json['isStaff'],
        'isActive': json['isActive'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
function UserDetailToJSON(json) {
    return UserDetailToJSONTyped(json, false);
}
function UserDetailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=userDetail.js.map